import {
  IEducatorLinkPlayerProps,
  IActivity,
  LinkPlayerLanguages,
  ILinkPlayerLoaderProps
} from "./educator-link-player.props";
import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import ActivitySelector from "../activity-selector/activity-selector";
import LanguageEnum from "../../enums/language.enum";
import LanguageSelector from "../language-selector/language-selector";
import "./educator-link-player.scss";

const LinkPlayer = React.lazy(() =>
  import("./link-player-loader").catch((err) => {
    console.error("ERROR", err);
    return { default: () => <div>ERROR</div> };
  })
);

const EducatorLinkPlayer = (props: IEducatorLinkPlayerProps) => {
  const { isReview, studentId, reviewActivities, selectedReviewActivity, ctkEnvId, ctkEnvUrl } = props;
  const [showLinkPlayer, setShowLinkPlayer] = useState(true);
  const [selectedActivity, setSelectedActivity] = useState<IActivity | undefined>(selectedReviewActivity);
  const [selectedLanguage, setSelectedLanguage] = useState<LanguageEnum | undefined>(props.selectedLanguage);
  const [linkPlayerLoaderProps, setLinkPlayerLoaderProps] = useState<ILinkPlayerLoaderProps>({
    playerBaseUrl: props.playerBaseUrl,
    linkPlayerProps: {
      hierarchyId: props.lessonHierarchyId,
      pathId: reviewActivities[0].pathId,
      pathVersion: isReview ? reviewActivities[0].pathVersion : undefined,
      attemptId: isReview ? reviewActivities[0]?.takeId || uuidv4() : uuidv4(),
      studentId: isReview ? studentId : undefined,
      mode: "REVIEW",
      isPreview: !isReview,
      language: LinkPlayerLanguages[selectedLanguage || 0],
      externalTokenKey: "authToken",
      hideExitButton: true,
      ctkEnvId: ctkEnvId,
      ctkEnvUrl: ctkEnvUrl,
      setError: (errorMessage: string) => {
        console.error("Link Player Error: ", errorMessage || "Unknown error");
      }
    }
  });

  const handleActivitySelect = async (activity?: IActivity) => {
    setShowLinkPlayer(false);
    if (activity) {
      setSelectedActivity(activity);
      setLinkPlayerLoaderProps({
        ...linkPlayerLoaderProps,
        linkPlayerProps: {
          ...linkPlayerLoaderProps.linkPlayerProps,
          attemptId: activity.takeId || uuidv4(),
          pathId: activity.pathId
        }
      });
      setTimeout(() => {
        setShowLinkPlayer(true);
      }, 1000);
    }
  };

  const handleLanguageSelect = (selectedLanguage: LanguageEnum) => {
    setShowLinkPlayer(false);
    setSelectedLanguage(selectedLanguage);

    const languageId = Object.keys(LanguageEnum).find(
      (key) => LanguageEnum[key as keyof typeof LanguageEnum] === selectedLanguage
    ) as keyof typeof LanguageEnum | undefined;

    setLinkPlayerLoaderProps({
      ...linkPlayerLoaderProps,
      linkPlayerProps: {
        ...linkPlayerLoaderProps.linkPlayerProps,
        language: LinkPlayerLanguages[languageId || 0]
      }
    });
    setTimeout(() => {
      setShowLinkPlayer(true);
    }, 1000);
  };

  return (
    <div className="tier-1-preview-header">
      <div className="tier-1-preview-dropdowns-row">
        <div className="tier-1-preview-dropdown">
          <ActivitySelector
            activities={reviewActivities}
            selectedActivity={selectedActivity}
            handleActivitySelect={handleActivitySelect}
          />
        </div>
        {!isReview && (
          <div className="tier-1-preview-dropdown">
            <LanguageSelector selectedLanguage={selectedLanguage} handleLanguageSelect={handleLanguageSelect} />
          </div>
        )}
      </div>
      {showLinkPlayer && (
        <div className="lesson-link-player">
          <LinkPlayer values={{ ...linkPlayerLoaderProps }} />
        </div>
      )}
    </div>
  );
};

export default EducatorLinkPlayer;
